<template>
  <div :class="{'container-dark': theme_dark}">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">提现记录</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/发布.png" class="nav-img none" />
      </div>
    </div>

    <div class="menu-block">
      <div class="ub ub-pc menu-item" v-if="arr.length > 0">
        <span class="width6">申请金额</span>
        <span class="width6">手续费</span>
        <span class="width6">发放金额</span>
        <span class="width7">状态</span>
        <span class="ub ub-f1 ub-ae dtm-key">日期</span>
      </div>

      <li v-for="(item,index) in  arr" :key="index" >
        <div class="menu-line"></div>
        <div class="ub ub-pc ub-ac menu-item">
            <span class="width6">¥{{item.tx_mny}}</span>
            <span class="width6">¥{{item.fee}}</span>
            <span class="width6">¥{{item.pay_mny}}</span>

            <span class="width7 apply-state-true" v-if="item.state=='成功'">{{item.state}}<br/><a @click="alert_dtl(item.brife)">(详情)</a></span>
            <span class="width7 apply-state-false" v-if="item.state=='失败'">{{item.state}}<br/><a @click="alert_dtl(item.brife)">(详情)</a></span>
            <span class="width7 apply-state-audit" v-if="item.state=='待审核'">{{item.state}} <br/><a @click="alert_dtl(item.brife)">(详情)</a></span>
            
            <div class="item-date ub ub-ver ub-pc">
                <span>{{item.date}}</span>
                <span>{{item.time}}</span>
            </div>
        </div>
        <div v-if="index < arr.length-1" class="menu-line"></div>
      </li>

      <div class="ub ub-pc ub-ver no-data" v-if="arr.length <= 0">
        <img src="../../assets/img/暂无数据.png" class="no-data-img" />
        <div class="no-data-txt">暂无提现明细(ಥ_ಥ)</div>
        <div class="ub ub-ac ub-pc menu-money-btn" @click="goto_mkmny()">研究挣钱攻略>></div>
      </div>
    </div>

    <dlg ref="myConfirm"></dlg>
  </div>


</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";
import Form from "../../components/Form.vue";
export default {
  components: {
      dlg: Form
    },
  data() {
    return {
      arr: [],
      theme_dark: false
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法

    back() {
      this.$router.go(-1); //返回上一层
    },
    goto_mkmny() {
      this.$router.push({ name: "mkmny" });
    },
    init_page() {
      var self = this;
      var uid = self.$store.state.uid;
      self.get({
        url: "/App/GetTxData/?uid=" + uid,
        success: function(data_serve) {
          self.arr = data_serve;
          // 处理每个数据对象，将日期和时间分开
          data_serve.forEach(function(item) {
            if (item.dtm) {
              var dtmParts = item.dtm.split(' ');
              item.date = dtmParts[0];
              item.time = dtmParts[1];
            }
          });
        },
        error: function(err) {
        }
      });
    },

    alert_dtl(brife){
      if(!brife){
        brife = '正在审核中，请耐心等待一哈；';
      }
      var ctxt = '';
          ctxt += '<div style="font-size: .85em;line-height: 1.8em;color: #666;">';
          ctxt += brife;
          ctxt += '。 如有其他疑问，可添加客服微信【xhczjj201712】了解更多详情，添加时请备注“提现”。';
          ctxt += '</div>';
          this.$refs.myConfirm.show(ctxt, {
            type: "confirm",
            confirmText: "知道了",
            titleText: "提现结果",
            data: ""
          });
    }

  }
};
</script>

<style lang="scss" scoped>
.menu-block {
  padding: 0.2rem 0.8rem;
  background-color: #fff;
  .menu-item {
    height: 3rem;
    justify-content: space-between;
    .width6 {
      text-align: center;
      width: 4.5rem;
      font-size: .83rem;
    }
    .width7 {
      display: inline-block;
      width: 5rem;
      font-size: .83rem;
      text-align: center;
      a{
        font-size: .6rem;
        color: rgb(186, 97, 255);
      }
    }
    .dtm-key{
      font-size: .83rem;
    }
    .apply-state-true {
      color: #04f82d;
    }

    .apply-state-false {
      color: red;
    }

    .apply-state-audit {
      color: #dcdcdc;
    }
    .item-date {
      span {
          font-size: 0.75rem;
      }
    }
    .item-date span:nth-child(2) {
      margin-top: 0.5rem;
    }
  }
}

.no-data {
  padding: 5rem 0;
  .no-data-img {
    width: 9rem;
    height: 9rem;
  }

  .no-data-txt {
    margin-top: 1rem;
    color: #afafaf;
    margin-left: 0.5rem;
  }

  .menu-money-btn {
    background-color: #e92162;
    width: 8rem;
    height: 2rem;
    line-height: 2rem;
    border-radius: 0.3rem;
    color: #fff;
    font-size: 1rem;
    margin-top: 1.2rem;
  }
}

.menu-line {
  border-top: 1px solid #EFEFEF;
}

.container-dark {
  min-height: 100vh;
  background-color: #2F2E33;
  .menu-block {
    background-color: #2c2b30;
    .menu-item {
      span {
        color: #FDFDFD;
      }
      .apply-state-true {
        color: #04f82d;
      }
      .apply-state-false {
        color: red;
      }
      .apply-state-audit {
        color: #dcdcdc;
      }
    }
  }
  .menu-line {
    border-top: 1px solid #404040;
  }
}
</style>